var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Website visits")]),_c('ViewsTable',{attrs:{"views":_vm.views}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }